import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import PageWrapper from './PageWrapper';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-dark overflow-x-hidden relative">
      <div className="fixed inset-0 bg-starfield bg-[length:400px_400px] pointer-events-none z-0" aria-hidden="true" />
      <Navbar />
      <main className="flex-grow">
        <PageWrapper>
          {children}
        </PageWrapper>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
